import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import Time from "react-time-format";
import "./rent.css";
import "./detailOfRent.css";

const DetailOfRent = () => {
  return (
    <ProductConsumer>
      {(value) => {
        const {
          R_mob,
          R_nawe_barez,
          R_zh_barez,
          R_zh_wasl,
          R_joripara,
          R_wargr,
          R_wasl,
          R_date,
        } = value;
        return (
          <form className="rd-card">
            {/* row 1 */}
            <div className="rd-row">
              <div className="rd-cell rd-cell--stamp">
                <Time
                  value={R_date}
                  format="YYYY-MM-DD"
                  className="rd-stamp"
                />
              </div>

              <div className="rd-cell">
                <div className="rd-field">
                  <label className="rd-label">تەلەفۆن</label>
                  <span className="rd-value">{R_mob}</span>
                </div>
              </div>

              <div className="rd-cell">
                <div className="rd-field">
                  <label className="rd-label">بەڕێز</label>
                  <span className="rd-value">{R_nawe_barez}</span>
                </div>
              </div>

              <div className="rd-cell">
                <div className="rd-field">
                  <label className="rd-label">بەڕێز ژمارە</label>
                  <span className="rd-value">{R_zh_barez}</span>
                </div>
              </div>
            </div>

            {/* row 2 */}
            <div className="rd-row">
              <div className="rd-cell rd-cell--stamp">
                <Time
                  value={R_date}
                  format="hh:mm:ss"
                  className="rd-stamp rd-stamp--time"
                />
              </div>

              <div className="rd-cell">
                <div className="rd-field">
                  <label className="rd-label">ناوی وەرگر</label>
                  <span className="rd-value">{R_wargr}</span>
                </div>
              </div>

              <div className="rd-cell">
                <div className="rd-field">
                  <label className="rd-label">جۆری دراو</label>
                  <span className="rd-value">{R_joripara}</span>
                </div>
              </div>

              <div className="rd-cell">
                <div className="rd-field">
                  <label className="rd-label">ژمارەی پسوولە</label>
                  <span className="rd-value">{R_zh_wasl}</span>
                </div>
              </div>
            </div>
          </form>
        );
      }}
    </ProductConsumer>
  );
};

export default DetailOfRent;
